module.exports = __webpack_public_path__ + "media/barometer_linkedin/wave-ce1eb622.png";